(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('[data-bm-event-variants]').textContent);
    const container=root.closest('.product-box, .product-newdefault')||root.closest('[data-product-container]')||root.parentElement;
    const label=root.querySelector('[data-bm-event-savings]');
    const message=root.querySelector('[data-bm-event-message]');
    const originalMessage=message&&message.textContent;
    const moneyOptions={style:'currency',currency:root.dataset.currency};
    const wholeMoney=new Intl.NumberFormat(document.documentElement.lang||'en-US',{...moneyOptions,minimumFractionDigits:0,maximumFractionDigits:0});
    const centsMoney=new Intl.NumberFormat(document.documentElement.lang||'en-US',{...moneyOptions,minimumFractionDigits:2,maximumFractionDigits:2});
    function selected(){
      const form=container.querySelector('form[data-product-form]');
      const controls=form?Array.from(form.querySelectorAll('select[data-product-option], input[data-product-option]:checked')):[];
      if(controls.length){const options=controls.map(s=>s.value);const match=data.variants.find(v=>v.options.length===options.length&&v.options.every((o,i)=>o===options[i]));if(match)return match;}
      const field=container.querySelector('form[action*="/cart/add"] [name="id"]');
      const id=field&&field.value||new URL(location.href).searchParams.get('variant')||String(data.selected);
      return data.variants.find(v=>String(v.id)===id);
    }
    function update(){
      const variant=selected();const state=variant&&variant.state;
      const override=variant&&variant.override;
      const hasOverride=override!==null&&override!==undefined;
      const overrideMatches=state&&(hasOverride?(state.variantOverride!=null&&Number(state.variantOverride)===Number(override)):state.variantOverride==null);
      const valid=overrideMatches&&state&&state.active===true&&state.reductionType===root.dataset.reductionType&&Number(state.reductionValue)===Number(root.dataset.reductionValue);
      const actual=variant?variant.price:NaN;
      const saved=state?Math.round(Number(state.appliedPrice)*100):NaN;
      const savings=variant?variant.compare-actual:0;
      root.hidden=!(valid&&actual===saved&&savings>0);
      if(!root.hidden){
        label.textContent=root.dataset.saveLabel.replace('__AMOUNT__',(savings%100?centsMoney:wholeMoney).format(savings/100));
        if(message){message.hidden=hasOverride&&Number(override)===0;message.textContent=hasOverride?root.dataset.saveLabel.replace('__AMOUNT__',wholeMoney.format(Number(override))):originalMessage;}
      }
    }
    const wrapper=container.querySelector('[data-price-wrapper]');
    if(wrapper)new MutationObserver(update).observe(wrapper,{childList:true,subtree:true,characterData:true});
    container.addEventListener('change',()=>{update();requestAnimationFrame(update);});
    window.addEventListener('popstate',update);
    update();
  }
  function start(){document.querySelectorAll('[data-bm-event-offer]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
